/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PricePutRequests } from '../../models/price-put-requests';
import { PricePutResponses } from '../../models/price-put-responses';

export interface CatalogsPricesPut$Params {
  'Active-Tenant-Identifier': string;
  integrations?: any;
      body: PricePutRequests
}

export function catalogsPricesPut(http: HttpClient, rootUrl: string, params: CatalogsPricesPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PricePutResponses>> {
  const rb = new RequestBuilder(rootUrl, catalogsPricesPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('integrations', params.integrations, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PricePutResponses>;
    })
  );
}

catalogsPricesPut.PATH = '/catalogs/prices';
